export const SEARCH_TYPE_IDS = {
  CLAIM_NUMBER: 'CLAIM_NUMBER',
  POLICY_NUMBER: 'POLICY_NUMBER',
  REGISTRATION_NUMBER: 'REGISTRATION_NUMBER',
};
